<script>
  import Conexoes from "../Classes/Conexoes";
  export let showModal = true;
  let dataInicio = "";
  let dataFim = "";
  let diasSelecionados = [];
  let horariosInicio = [{ hora: "" }];
  
  // NOVA VARIÁVEL: 0 = Presencial, 1 = Online
  let tipoAtendimento = 0; 
  
  let resposta;

  const diasDaSemana = [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado",
  ];

  import Constantes from "../Classes/Constantes";
  const conexao = new Conexoes(Constantes.url_base_nutri);

  function adicionarHorario() {
    horariosInicio = [...horariosInicio, { hora: "" }];
  }

  function removerHorario(index) {
    horariosInicio = horariosInicio.filter((_, i) => i !== index);
  }

  async function handleSubmit() {
    const dadosFormulario = {
      dataInicio,
      dataFim,
      diasSelecionados,
      horariosInicio,
      online: tipoAtendimento, // Enviando 0 ou 1 para a API
    };

    resposta = await conexao.conecta("criar_horarios.php", {
      body: dadosFormulario,
    });

    if (resposta.ok || resposta.mensagem) {
      alert("Horários criados com sucesso!");
    } else {
      alert("Erro ao criar horários.");
    }
  }

  function handleDiaChange(dia) {
    if (diasSelecionados.includes(dia)) {
      diasSelecionados = diasSelecionados.filter((d) => d !== dia);
    } else {
      diasSelecionados = [...diasSelecionados, dia];
    }
  }
</script>

{#if showModal}
  <div class="modal">
    <div class="modal-content">
      <h2>Criar Horários</h2>
      <form on:submit|preventDefault={handleSubmit} class="form-grid">
        
        <div class="form-group full-width">
            <label>Tipo de Atendimento:</label>
            <div class="radio-group">
                <label class="radio-label">
                    <input type="radio" bind:group={tipoAtendimento} value={0}>
                    <span class="ml-2">🏢 Presencial</span>
                </label>
                <label class="radio-label">
                    <input type="radio" bind:group={tipoAtendimento} value={1}>
                    <span class="ml-2">💻 Online</span>
                </label>
            </div>
        </div>

        <div class="form-group">
          <label for="dataInicio">Data de Início:</label>
          <input type="date" id="dataInicio" bind:value={dataInicio} required />
        </div>

        <div class="form-group">
          <label for="dataFim">Data de Fim:</label>
          <input type="date" id="dataFim" bind:value={dataFim} required />
        </div>

        <div class="form-group days-group full-width">
          <label>Dias da Semana:</label>
          <div class="days-checkboxes">
            {#each diasDaSemana as dia, index}
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  id="dia-{index}"
                  value={index}
                  checked={diasSelecionados.includes(index)}
                  on:change={() => handleDiaChange(index)}
                />
                {dia}
              </label>
            {/each}
          </div>
        </div>

        {#each horariosInicio as horario, index}
          <div class="form-group time-group full-width">
            <label for="horaInicio-{index}">Hora de Início {index + 1}:</label>
            <input
              type="time"
              id="horaInicio-{index}"
              bind:value={horario.hora}
              required
            />

            {#if index > 0}
              <button
                type="button"
                class="remove-button"
                on:click={() => removerHorario(index)}>Remover</button>
            {/if}
          </div>
        {/each}

        <div class="button-group">
          <button type="button" class="add-button" on:click={adicionarHorario}
            >Adicionar Horário</button
          >
          <button type="submit" class="submit-button">Criar Horários</button>
        </div>
      </form>
    </div>
  </div>
{/if}

<style>
  .modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 1050;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
    background-color: #fff;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    position: relative;
    max-width: 90%;
    width: 600px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  h2 {
    text-align: center;
    margin-bottom: 20px;
    color: #333;
  }

  .form-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 15px;
  }

  @media (min-width: 576px) {
    .form-grid {
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }
    /* Classe para forçar elementos a ocuparem a linha inteira em desktop */
    .full-width {
        grid-column: 1 / -1;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;
  }

  .form-group label {
    margin-bottom: 5px;
    font-weight: bold;
    color: #555;
  }

  /* Estilos para o Radio Button */
  .radio-group {
      display: flex;
      gap: 20px;
      margin-top: 5px;
      background: #f9f9f9;
      padding: 10px;
      border-radius: 5px;
      border: 1px solid #eee;
  }
  .radio-label {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-weight: normal !important;
  }
  .ml-2 { margin-left: 8px; }


  .form-group input[type="date"],
  .form-group input[type="time"] {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
  }

  .days-group label {
    display: block;
    margin-bottom: 5px;
  }

  .days-checkboxes {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
  }

  .time-group {
    display: flex;
    flex-direction: row; /* Forçar linha */
    align-items: center;
    gap: 10px;
  }
  
  /* Ajuste para input de hora ocupar espaço disponível na linha */
  .time-group input[type="time"] {
      flex-grow: 1; 
  }

  .remove-button {
    background-color: #f44336;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
  }

  .add-button,
  .submit-button {
    background-color: #4caf50;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 4px;
    cursor: pointer;
  }

  .button-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    grid-column: 1 / -1;
  }
</style>